import TerritoryModule from "@/pages/super-admin/components/TerritoryModule";

export default function SuperAdminProvincesPage() {
  return <TerritoryModule level="province" />;
}